const routes = [
    {
        path: "/certificate/centers",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "certificatecenter_index"
        }
    },

];

export default routes;
